<script>
    // Step Line Chart Renderer
    import StepLinePrimitive from './primitives/step_line.js'
    import Price from './primitives/price.js'
    import Volbar from '../../components/primitives/volbar.js'
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'StepLine',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'TradingCandle', 
                    version: '1.0.0',
                    desc: 'Step Line Chart',
                    preset: {
                        name: 'StepLine',
                        side: 'onchart',
                        settings: {
                            lineColor: '#2962ff',
                            lineWidth: 2,
                            showVolume: true,
                            priceLine: false
                        }
                    }
                }
            },
            init() {
                this.price = new Price(this)
            },
            draw(ctx) {
                let layout = this.$props.layout
                let candles = this.$props.sub === this.$props.data ?
                    layout.candles : layout_cnv(this).candles
                
                if (candles.length > 0) {
                    new StepLinePrimitive(this, ctx, layout, candles)
                }

                if (this.price_line) this.price.draw(ctx)
                
                // Draw volume bars if enabled
                if (this.show_volume) {
                    let cnv = layout_cnv(this)
                    for (var i = 0, n = cnv.volume.length; i < n; i++) {
                        new Volbar(this, ctx, cnv.volume[i])
                    }
                }
            },
            use_for() { return ['StepLine'] },

            // When added as offchart overlay
            y_range() {
                if (!this.$props.sub.length) return [0, 0]
                return [
                    Math.max(...this.$props.sub.map(x => x[2])),
                    Math.min(...this.$props.sub.map(x => x[3]))
                ]
            }
        },

        computed: {
            sett() {
                return this.$props.settings
            },
            show_volume() {
                return 'showVolume' in this.sett ?
                    this.sett.showVolume : true
            },
            price_line() {
                return 'priceLine' in this.sett ?
                    this.sett.priceLine : false
            },
            lineColor() {
                return this.sett.lineColor || "#2962ff"
            },
            lineWidth() {
                return this.sett.lineWidth || 2
            },
            colorVolUp() {
                return this.sett.colorVolUp ||
                this.$props.colors.volUp
            },
            colorVolDw() {
                return this.sett.colorVolDw ||
                this.$props.colors.volDw
            }
        }
    }
</script>
